import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(private titleService: Title) {}

  title = 'Rahil Hastu';
  ngOnInit(): void {
    this.titleService.setTitle(this.title);

    let frontR = document.querySelector('.frontR');
    let backR = document.querySelector('.backR');
    let logoRimg = <HTMLElement>document.querySelector('.imgR');
    let title = <HTMLElement[]>(<any>document.querySelectorAll('.title span'));
    let skillsLandingPage = <HTMLElement>(
      document.querySelector('.title .subtitle')
    );

    let counter = 0,
      widthLoading = 0;
    let loadingComplete = <HTMLElement>(
      document.querySelector('.loading-complete')
    );

    //Related -> Big R Logo Animation
    frontR.classList.add('animateFront');
    backR.classList.add('animateBack');
    setTimeout(() => {
      frontR.classList.add('fillFront');
      backR.classList.add('fillBack');
    }, 800);
    setTimeout(fading, 2800);

    setTimeout(() => {
      let delay = 0;
      title.forEach((spanEle) => {
        spanEle.style.animation = `comeout 1s ease ${delay}s forwards`;
        delay += 0.05;
      });
      skillsLandingPage.style.opacity = '1';
    }, 400);

    function fading() {
      var increment = 0.015;
      var opacity = 0;
      var instance = window.setInterval(function () {
        logoRimg.style.opacity = String(opacity);
        opacity = opacity + increment;
        if (opacity >= 1) {
          window.clearInterval(instance);
        }
      }, 0);
    }

    title.forEach((spanTag) => {
      spanTag.addEventListener('mouseover', () => {
        spanTag.style.opacity = '1';
        spanTag.style.animation = '';
        spanTag.classList.toggle('bounce');
      });
    });
  }
}
